import React from 'react';
import { useNavigate } from 'react-router-dom';

import ArrowIcon from '@hero/ui-kit/icons/utility/ArrowIcon';
import CaretIcon from '@hero/ui-kit/icons/utility/CaretIcon';
import ClickableOpacity from '@hero/ui-kit/inputs/ClickableOpacity';
import * as Style from './style.module.scss';
import type { Neighbor, Position } from './types';

type Props = {
    backLabel: string;
    backTo: string;
    prev: Neighbor;
    next: Neighbor;
    position: Position | undefined;
    backAlt?: string;
};

const ListNav: React.FC<Props> = ({ backLabel, backTo, prev, next, position, backAlt }) => {
    const navigate = useNavigate();

    const handleBack = () => navigate(backTo);
    const handlePrev = () => {
        if (prev) navigate(prev.url, { state: prev.forwardSnapshot });
    };
    const handleNext = () => {
        if (next) navigate(next.url, { state: next.forwardSnapshot });
    };

    const showCluster = !!position && position?.total > 1;

    const prevButton = (
        <ClickableOpacity
            onClick={handlePrev}
            alt={prev ? `Previous: ${prev.name}` : 'Previous'}
            className={`${Style.pageButton} label ${prev ? '' : 'ui-disabled'}`}
        >
            <CaretIcon direction="backward" size="utility" />
            {/*{prev && <span className={Style.neighborName}>{prev.name}</span>}*/}
        </ClickableOpacity>
    );

    const nextButton = (
        <ClickableOpacity
            onClick={handleNext}
            alt={next ? `Next: ${next.name}` : 'Next'}
            className={`${Style.pageButton} label ${next ? '' : 'ui-disabled'}`}
        >
            {/*{next && <span className={Style.neighborName}>{next.name}</span>}*/}
            <CaretIcon direction="forward" size="utility" />
        </ClickableOpacity>
    );

    return (
        <div className={Style.nav}>
            <ClickableOpacity
                onClick={handleBack}
                alt={backAlt ?? backLabel}
                className={Style.back}
            >
                <ArrowIcon direction="backward" size="utility" strokeWidth={3} />
                <strong className="p-large">{backLabel}</strong>
            </ClickableOpacity>

            {showCluster && (
                <div className={Style.cluster}>
                    {prevButton}
                    <div className={`${Style.counter}`}>
                        {position.current} of {position.total}
                    </div>
                    {nextButton}
                </div>
            )}
        </div>
    );
};

export default ListNav;
